const _get = require('lodash.get');
function PaymentPaypalCtrl(
  $scope,
  $state,
  $timeout,
  Payment_transaction,
  AppAuthFactory,
  $location) {
  "ngInject";

  //well initially wait 10 seconds before initiating a query
  $timeout(getPaymentTransaction, 10000);

  $scope.loading = true;

  const wait = 5000;
  let retries = 24;

  function retry() {
    if (retries > 0) {
      retries--;
      $timeout(getPaymentTransaction, wait);
    }
    else {
      $state.go('error.ipn');
    }
  }

  function getPaymentTransaction() {
    console.log('__getPaymentTransaction__');
    const args = $location.search();

    let oneDayAgo = new Date();
    oneDayAgo.setDate(oneDayAgo.getDate() - 1);

    return Payment_transaction.findOne({
      "filter": {
        "where": {
          "and": [
            {"program_id": args.program_id},
            {"subscriber_id": args.subscriber_id},
            {"cause_id": args.cause_id},
            {"created": {"gt": oneDayAgo}}
          ]
        },
        "order": "id desc",
        "limit": 1,
        "include": ["subscription","cause"]
      }
    }).$promise.then( function successHandler(paymentTransaction) {
      console.log(paymentTransaction);
      if (!paymentTransaction.subscription) {
        retry();
      }
      else {
        //we need to renew the active subscription state now that a subscription exists
        AppAuthFactory.getAndPersistCurrentUser( (err, currentUser) => {
          $scope.loading = false;
          if(err || !currentUser) {
            return $state.go("error.ipn");
          }
          $scope.purchase = {
            date: paymentTransaction.created,
            cause: paymentTransaction.cause.name,
            amount: paymentTransaction.subscription.amount,
            started: paymentTransaction.subscription.begins,
            expires: paymentTransaction.subscription.expires,
            username: currentUser.email,
            first_name: currentUser.first_name,
            last_name: currentUser.last_name,
          };
        });
      }
    }, function errorHandler(err) {
      console.error(err);
      const errCode = _get(err, "data.error.code");
      if (errCode === "PAYMENT_PENDING_ECHECK") {
        return $state.go("error.echeck");
      }
      else {
        retry();
      }
    });
  }
}

export default PaymentPaypalCtrl;



// WEBPACK FOOTER //
// ./js/containers/users/controllers/payment-paypal.ctrl.js